import { insertImage } from '../../../elements/Element/image/utils'
import { insertEmbedAsset } from '../../../elements/Element/contentstack/image/Modal/ModalComponent'
import { insertEmbedEntry } from '../../../elements/Element/contentstack/reference/utils/referenceButton'
import { getEmbedLinkDetails } from '../../../elements/Element/contentstack/reference/utils/utils'
import { v4 } from 'uuid'
import { isPlainObject } from 'lodash'

function useRTEEmbedListeners({ editor, entryMetadata, fieldMetadata }) {
  const referenceTo = fieldMetadata?.reference_to ?? []

  if (editor.useV2EmbedPicker) {
    editor.showAssetEmbedModal = ({ type }) => {
      try {
        const uuid = v4()
        const data = {
          uuid,
          allowOnlyImages: type !== 'asset',
          allowMultipleImageSelect: true
        }

        window.dispatchEvent(new CustomEvent('showAssetEmbedModal', { detail: data }))

        window.addEventListener(
          `${uuid}-assetEmbed`,
          (e: CustomEvent) => {
            const { asset } = e.detail
            if (!asset || !Array.isArray(asset)) return
            if (type === 'asset') {
              insertEmbedAsset({ editor, asset })
            } else {
              asset.reverse().forEach((eachAsset) => {
                insertImage(editor, eachAsset.url, {
                  asset_uid: eachAsset.uid,
                  alt: eachAsset?.description || eachAsset?.title
                })
              })
            }
          },
          { once: true }
        )
      } catch (e) {
        console.error(e)
      }
    }

    editor.showEntryEmbedModal = ({ prefilled = false, type, attributes }) => {
      try {
        const uuid = v4()
        const data = {
          uuid,
          referenceTo,
          showDisplayTypeSelector: type !== 'link',
          showEmbedLinkSection: type === 'link',
          initialData: null,
          isReplace: !!prefilled
        }
        const linkDetails = getEmbedLinkDetails(editor)
        if (linkDetails?.text) {
          data.initialData = {
            linkTitle: linkDetails?.text
          }
        }
        if (prefilled) {
          data.initialData = {
            entryUid: attributes?.['entry-uid'],
            contentTypeUid: attributes?.['content-type-uid'],
            locale: attributes?.['locale'],

            isInline: attributes?.['display-type'] === 'inline',
            openInNewTab: linkDetails?.inNewTab,
            linkTitle: linkDetails?.text
          }
        }
        if(linkDetails && linkDetails['title']) {
          if(!data.initialData) data.initialData = {}
          data.initialData.title = linkDetails['title']
        }

        window.dispatchEvent(new CustomEvent('showEntryEmbedModal', { detail: data }))
        window.addEventListener(
          `${uuid}-entryEmbed`,
          (e: CustomEvent) => {
            const { entry, openInNewTab, linkTitle, isInline, title } = e.detail
            if (!entry || !isPlainObject(entry)) return

            const displayType = !type && isInline ? 'inline' : 'block'
            const linkDetails = {
              inNewTab: openInNewTab,
              text: linkTitle,
              href: entry.url,
              title
            }
            const contentTypeUid = entry._content_type_uid
            entry.contentTypeUid = contentTypeUid
            insertEmbedEntry({
              editor,
              entry,
              contentTypeUid,
              displayType,
              attributes,
              linkDetails,
              prefilled,
              type
            })
          },
          { once: true }
        )
      } catch (e) {
        console.error(e)
      }
    }
  }

  if (editor.isDraft) {
    editor.getReferredObj = ({ ctUid, blockUid, pathname, search }) => {
      if (!entryMetadata || !ctUid || !blockUid || !pathname || !fieldMetadata) return {}
      const referredObjPayload = {
        entry_title: entryMetadata?.entryTitle ?? '',
        entry_uid: entryMetadata?.entryUid,
        variant_uid: entryMetadata?.variantUid,
        form_uid: entryMetadata?.contentTypeUid,
        locale: entryMetadata?.locale,
        location_to_push: {
          pathname,
          search
        },
        multiInstance: false,
        referred_field_uid: fieldMetadata.uid,
        referred_field_$uid: fieldMetadata.$uid,
        type: entryMetadata?.entryUid ? 'edit' : 'create',
        _content_type_uid: ctUid
      }

      return { referredObjPayload }
    }
  }
}

export default useRTEEmbedListeners
